
import { EVENT_BUNDLE_BUILDER } from '~~/constants/googleTagManager';

export const buildBundleBuilderViewTags = ({ sku }: { sku: string }) => ({
  event: EVENT_BUNDLE_BUILDER.VIEW,
  product_id: sku,
});
